import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Nav from '../components/nav';
import SEO from '../components/SEO';
import {
  FiArrowLeft, FiMessageSquare, FiSend
} from 'react-icons/fi';
import {
  FaLock, FaShieldAlt, FaEyeSlash, FaTrashAlt,
  FaBan, FaGlobe, FaFolder,
  FaBell, FaMobileAlt, FaCheckDouble,
  FaUserSecret
} from 'react-icons/fa';
import {
  MdOutlineDevices, MdOutlineGroups, MdOutlineHistory
} from 'react-icons/md';
import { IoSparkles } from 'react-icons/io5';
import { LuClapperboard } from 'react-icons/lu';
import { BsChatDotsFill, BsFileEarmarkText, BsPeopleFill } from 'react-icons/bs';
import { TbMessageOff } from 'react-icons/tb';
import { PiFilmSlateDuotone } from 'react-icons/pi';

const injectStyles = () => {
  if (document.getElementById('msg-page-styles')) return;
  const style = document.createElement('style');
  style.id = 'msg-page-styles';
  style.textContent = `
    @import url('https://fonts.googleapis.com/css2?family=Playfair+Display:ital,wght@0,700;0,900;1,700&family=DM+Sans:wght@400;500;600;700&display=swap');
    * { box-sizing: border-box; margin: 0; padding: 0; }

    @keyframes fadeUp   { from { opacity:0; transform:translateY(32px); } to { opacity:1; transform:translateY(0); } }
    @keyframes floatY   { 0%,100% { transform:translateY(0); } 50% { transform:translateY(-14px); } }
    @keyframes gradMove { 0%,100% { background-position:0% 50%; } 50% { background-position:100% 50%; } }
    @keyframes pulse    { 0%,100% { opacity:1; } 50% { opacity:0.3; } }
    @keyframes typing   { 0%,60%,100% { transform:translateY(0); } 30% { transform:translateY(-5px); } }
    @keyframes countUp  { from { opacity:0; transform:scale(0.7); } to { opacity:1; transform:scale(1); } }
    @keyframes slideIn  { from { opacity:0; transform:translateX(-24px); } to { opacity:1; transform:translateX(0); } }

    @keyframes glowFlow {
      0%   { box-shadow: 0 0 8px 2px rgba(0,180,130,0.25), 0 0 24px 4px rgba(0,128,128,0.15); }
      25%  { box-shadow: 4px 0 12px 3px rgba(0,200,160,0.35), -4px 0 24px 6px rgba(0,128,128,0.1); }
      50%  { box-shadow: 0 0 20px 5px rgba(0,229,176,0.4), 0 0 40px 8px rgba(0,128,128,0.2); }
      75%  { box-shadow: -4px 0 12px 3px rgba(0,200,160,0.35), 4px 0 24px 6px rgba(0,128,128,0.1); }
      100% { box-shadow: 0 0 8px 2px rgba(0,180,130,0.25), 0 0 24px 4px rgba(0,128,128,0.15); }
    }

    @keyframes borderPulse {
      0%,100% { border-color: rgba(0,180,130,0.4); }
      50%      { border-color: rgba(0,229,176,0.9); }
    }

    .msg-hero-title {
      font-family: 'Playfair Display', serif;
      font-size: clamp(40px, 6vw, 76px);
      font-weight: 900;
      line-height: 1.07;
      letter-spacing: -0.02em;
      color: #f9fafb;
    }
    .msg-gradient-text {
      background: linear-gradient(135deg, #00e5b0, #008080, #00e5b0);
      background-size: 200% auto;
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      background-clip: text;
      animation: gradMove 4s ease infinite;
    }

    /* ── WHITE BOX CARD with animated teal glow ── */
    .msg-card {
      background: #ffffff;
      border: 2px solid rgba(0,180,130,0.4);
      border-radius: 20px;
      transition: all 0.35s cubic-bezier(0.34,1.56,0.64,1);
      animation: glowFlow 4s ease-in-out infinite, borderPulse 4s ease-in-out infinite;
    }
    .msg-card:hover {
      transform: translateY(-6px);
      animation: glowFlow 1.5s ease-in-out infinite, borderPulse 1.5s ease-in-out infinite;
      box-shadow: 0 0 32px 8px rgba(0,229,176,0.5), 0 0 64px 16px rgba(0,128,128,0.25) !important;
    }
    .msg-card h3 { color: #0a2a2a !important; }
    .msg-card p  { color: #2d5a5a !important; }

    /* ── COMPARISON BOX white ── */
    .comparison-box {
      background: #ffffff;
      border: 2px solid rgba(0,180,130,0.4);
      border-radius: 22px;
      overflow: hidden;
      animation: glowFlow 5s ease-in-out infinite, borderPulse 5s ease-in-out infinite;
    }

    .msg-cta-primary {
      background: linear-gradient(135deg, #008080, #00b899);
      color: #fff;
      border: none;
      border-radius: 50px;
      padding: 16px 36px;
      font-size: 16px;
      font-weight: 700;
      cursor: pointer;
      font-family: 'DM Sans', sans-serif;
      box-shadow: 0 8px 32px rgba(0,128,128,0.35);
      transition: all 0.3s ease;
      letter-spacing: 0.02em;
      display: inline-flex;
      align-items: center;
      gap: 8px;
    }
    .msg-cta-primary:hover {
      transform: translateY(-3px);
      box-shadow: 0 16px 48px rgba(0,128,128,0.5);
      filter: brightness(1.1);
    }
    .msg-cta-ghost {
      background: transparent;
      color: rgba(255,255,255,0.65);
      border: 1px solid rgba(255,255,255,0.18);
      border-radius: 50px;
      padding: 16px 36px;
      font-size: 16px;
      font-weight: 600;
      cursor: pointer;
      font-family: 'DM Sans', sans-serif;
      transition: all 0.3s ease;
      display: inline-flex;
      align-items: center;
      gap: 8px;
    }
    .msg-cta-ghost:hover {
      background: rgba(255,255,255,0.08);
      border-color: rgba(255,255,255,0.35);
      color: #fff;
    }
    .pill-badge {
      display: inline-flex;
      align-items: center;
      gap: 6px;
      background: rgba(0,180,130,0.08);
      border: 1px solid rgba(0,180,130,0.22);
      border-radius: 50px;
      padding: 6px 14px;
      font-size: 12px;
      font-weight: 600;
      color: rgba(255,255,255,0.6);
      transition: all 0.25s ease;
      cursor: default;
    }
    .pill-badge:hover {
      background: rgba(0,180,130,0.16);
      border-color: rgba(0,180,130,0.42);
      color: #fff;
    }
    .stat-num {
      font-family: 'Playfair Display', serif;
      font-size: clamp(34px,5vw,54px);
      font-weight: 900;
      background: linear-gradient(135deg, #00e5b0, #008080);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      background-clip: text;
      animation: countUp 0.8s cubic-bezier(0.34,1.56,0.64,1) both;
    }
    .typing-dot {
      width: 7px; height: 7px; border-radius: 50%;
      background: #00b899;
      animation: typing 1.2s ease-in-out infinite;
    }

    /* ── PROBLEM CARD white ── */
    .problem-card {
      background: #ffffff;
      border: 2px solid rgba(239,68,68,0.3);
      border-radius: 14px;
      padding: 14px 18px;
      display: flex;
      align-items: flex-start;
      gap: 14px;
      transition: all 0.3s ease;
      box-shadow: 0 0 8px 2px rgba(239,68,68,0.1);
      animation: fadeUp 0.5s ease both;
    }
    .problem-card:hover {
      box-shadow: 0 0 20px 6px rgba(239,68,68,0.2);
      transform: translateY(-2px);
    }

    /* ── SECURITY PILL white ── */
    .security-pill {
      display: inline-flex;
      align-items: center;
      gap: 6px;
      background: #ffffff;
      border: 2px solid rgba(0,180,130,0.5);
      border-radius: 50px;
      padding: 8px 16px;
      font-size: 13px;
      font-weight: 600;
      color: #006060;
      transition: all 0.25s ease;
      cursor: default;
      animation: glowFlow 4s ease-in-out infinite;
    }
    .security-pill:hover {
      background: #f0fffe;
      box-shadow: 0 0 16px 4px rgba(0,180,130,0.35);
    }

    @media (max-width: 768px) {
      .msg-hero-grid   { grid-template-columns: 1fr !important; }
      .comparison-grid { grid-template-columns: 1fr !important; }
      .features-grid   { grid-template-columns: 1fr !important; }
      .stats-grid      { grid-template-columns: 1fr 1fr !important; }
      .problem-grid    { grid-template-columns: 1fr !important; }
    }
  `;
  document.head.appendChild(style);
};

const CHAT_MESSAGES = [
  { from: 'Kavya R.', role: 'Director', msg: 'Script for scene 14 is locked. Sharing now.', time: '9:41 AM', right: false, initials: 'K', delay: '0.1s' },
  { from: 'You', role: '', msg: 'Got it! Rehearsal confirmed for tomorrow 8 AM', time: '9:42 AM', right: true, initials: 'Y', delay: '0.35s' },
  { from: 'Rohan D.', role: 'DOP', msg: 'Location light check done. Delhi alley is perfect for night shot.', time: '9:44 AM', right: false, initials: 'R', delay: '0.6s' },
  { from: 'You', role: '', msg: 'Updated call sheet going out to full crew now.', time: '9:45 AM', right: true, initials: 'Y', delay: '0.85s' },
  { from: 'Meera S.', role: 'Casting', msg: 'Lead actress confirmed. She loved the script.', time: '9:47 AM', right: false, initials: 'M', delay: '1.1s' },
];

const FEATURES = [
  { Icon: FaLock, title: 'End-to-End Encrypted', desc: 'Every word, every file, every idea you share is fully encrypted. Only you and the people you message can read it. No one else — not even us.' },
  { Icon: LuClapperboard, title: 'Organised by Production', desc: 'Create a dedicated space for each film project. Director, DOP, cast, crew — all in the right conversation, nothing lost, nothing mixed up.' },
  { Icon: BsFileEarmarkText, title: 'Share Files in Chat', desc: 'Scripts, call sheets, location photos, budget sheets — send them directly in the conversation. No email attachments, no third-party links.' },
  { Icon: MdOutlineGroups, title: 'Group Conversations', desc: 'One group for the full crew. Separate groups for departments. You decide the structure. Your production, your rules.' },
  { Icon: FaCheckDouble, title: 'Read Receipts', desc: 'Know instantly when your AD received the call sheet, when the actor read the script note, when the DOP confirmed the schedule.' },
  { Icon: FaBell, title: 'Smart Notifications', desc: 'Get notified for what matters. Mute what does not. Stay in control of your attention on and off the set.' },
  { Icon: MdOutlineHistory, title: 'Full Message History', desc: 'Every conversation is saved and searchable. Find that location note from three months ago in seconds.' },
  { Icon: MdOutlineDevices, title: 'Any Device, Anytime', desc: 'Start a conversation on your laptop on set. Continue on your phone in the car. Everything syncs instantly.' },
  { Icon: FaBan, title: 'Zero Ads. Zero Spam.', desc: 'ProducerBuddy is a professional tool, not an advertising platform. Your conversations are never scanned, analysed or monetised.' },
];

const COMPARISON = [
  ['Mixed personal and work messages', 'A focused workspace for your production'],
  ['Files disappear in chat history', 'Files linked directly to your project'],
  ['No context about who does what', "Everyone's role is clear from day one"],
  ['Random group names and chaos', 'Organised channels by department'],
  ['Data used to target you with ads', 'Your data belongs to you — always'],
  ['Built for everyone — optimised for none', 'Built exclusively for the film industry'],
];

const PROBLEMS = [
  { Icon: TbMessageOff, problem: 'Lost in hundreds of group messages', who: 'Every filmmaker, ever' },
  { Icon: FaEyeSlash, problem: 'Script shared openly — anyone can screenshot', who: 'Directors and Writers' },
  { Icon: BsPeopleFill, problem: 'No idea who to contact or how to reach them', who: 'Film Enthusiasts and Newcomers' },
  { Icon: FaMobileAlt, problem: 'Personal number shared with entire crew', who: 'Everyone on the team' },
  { Icon: FaFolder, problem: 'Files buried, versions mixed up, chaos', who: 'Producers and ADs' },
];

const SECURITY_ITEMS = [
  { Icon: FaLock, label: 'Messages encrypted in transit and at rest' },
  { Icon: FaShieldAlt, label: 'Data never sold to any third party' },
  { Icon: FaEyeSlash, label: 'No message scanning or AI monitoring' },
  { Icon: FaBan, label: 'No advertisements inside the platform' },
  { Icon: FaTrashAlt, label: 'Delete any message or conversation anytime' },
  { Icon: FaGlobe, label: 'Secure infrastructure — always online' },
];

const TRUST_PILLS = [
  { Icon: FaLock, label: 'End-to-End Encrypted' },
  { Icon: FaBan, label: 'Zero Ads' },
  { Icon: FaShieldAlt, label: 'Data Never Sold' },
  { Icon: FaCheckDouble, label: 'Free Forever' },
  { Icon: MdOutlineDevices, label: 'Any Device' },
];

const MessagingFeaturePage = () => {
  const navigate = useNavigate();
  const [loggedIn] = useState(() => !!localStorage.getItem('access_token'));

  useEffect(() => { injectStyles(); }, []);

  const goToMessenger = () => navigate(loggedIn ? '/messenger' : '/signup');

  return (
    <>
      <SEO
        title="Film Team Messaging Features"
        description="Explore ProducerBuddy's in-built messenger — real-time chat, file sharing, and project communication purpose-built for film production teams."
        url="https://producerbuddy.pilomation.com/understandpilo-messenger"
      />
      <Nav />
      <div style={{ minHeight: '100vh', background: '#050c18', fontFamily: "'DM Sans', sans-serif", color: '#f9fafb', overflowX: 'hidden' }}>

        {/* ── Background ── */}
        <div style={{ position: 'fixed', inset: 0, pointerEvents: 'none', zIndex: 0 }}>
          <div style={{ position: 'absolute', width: 700, height: 700, borderRadius: '50%', background: 'radial-gradient(circle, rgba(0,128,128,0.1) 0%, transparent 65%)', top: -200, left: -200 }} />
          <div style={{ position: 'absolute', width: 500, height: 500, borderRadius: '50%', background: 'radial-gradient(circle, rgba(0,200,150,0.07) 0%, transparent 65%)', bottom: 0, right: -100 }} />
          <div style={{ position: 'absolute', inset: 0, backgroundImage: 'radial-gradient(rgba(0,180,130,0.04) 1px, transparent 1px)', backgroundSize: '44px 44px' }} />
        </div>

        {/* ── Navbar ── */}
        {/* <nav style={{ position: 'sticky', top: 0, zIndex: 100, backdropFilter: 'blur(24px)', background: 'rgba(5,12,24,0.85)', borderBottom: '1px solid rgba(0,180,130,0.1)', padding: '0 clamp(16px,4vw,48px)', height: 64, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <button onClick={() => navigate(-1)} style={{ background: 'rgba(255,255,255,0.05)', border: '1px solid rgba(255,255,255,0.1)', borderRadius: 50, padding: '7px 16px', color: 'rgba(255,255,255,0.6)', cursor: 'pointer', fontSize: 13, fontWeight: 600, display: 'flex', alignItems: 'center', gap: 6 }}>
            <FiArrowLeft size={14} /> Back
          </button>
          <div style={{ display: 'flex', alignItems: 'center', gap: 9 }}>
            <div style={{ width: 34, height: 34, borderRadius: 10, background: 'linear-gradient(135deg,#008080,#00b899)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <BsChatDotsFill size={16} color="#fff" />
            </div>
            <span style={{ fontFamily: "'Playfair Display',serif", fontWeight: 700, fontSize: 16, color: '#f9fafb' }}>PB Messaging</span>
          </div>
          <button className="msg-cta-primary" style={{ padding: '9px 22px', fontSize: 13 }} onClick={goToMessenger}>
            <FiMessageSquare size={14} />
            {loggedIn ? 'Open Messenger' : 'Start Free'}
          </button>
        </nav> */}

        <div style={{ position: 'relative', zIndex: 1 }}>

          {/* ════════════ HERO ════════════ */}
          <section style={{ maxWidth: 1160, margin: '0 auto', padding: 'clamp(64px,10vw,110px) clamp(16px,4vw,48px) 60px' }}>
            <div className="msg-hero-grid" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 'clamp(32px,5vw,72px)', alignItems: 'center' }}>

              {/* Left copy */}
              <div style={{ animation: 'slideIn 0.7s ease both' }}>
                <div style={{ display: 'inline-flex', alignItems: 'center', gap: 8, background: 'rgba(0,180,130,0.1)', border: '1px solid rgba(0,180,130,0.25)', borderRadius: 50, padding: '6px 16px', fontSize: 12, fontWeight: 700, color: '#00e5b0', letterSpacing: '0.07em', textTransform: 'uppercase', marginBottom: 28 }}>
                  <LuClapperboard size={13} /> Built for Indian Cinema
                </div>
                <h1 className="msg-hero-title" style={{ marginBottom: 24 }}>
                  Every Great Film<br />Starts With a<br />
                  <span className="msg-gradient-text">Conversation.</span>
                </h1>
                <p style={{ fontSize: 18, lineHeight: 1.8, color: 'rgba(255,255,255,0.52)', marginBottom: 36, maxWidth: 500 }}>
                  From the first idea whispered between two filmmakers to the final call sheet sent to a fifty-person crew — ProducerBuddy Messaging is where Indian cinema comes together. Secure. Organised. Made for the way films are actually made.
                </p>
                <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap', marginBottom: 32 }}>
                  <button className="msg-cta-primary" onClick={goToMessenger}>
                    <BsChatDotsFill size={15} />
                    {loggedIn ? 'Open Messenger' : 'Start Messaging Free'}
                  </button>
                  <button className="msg-cta-ghost" onClick={() => navigate('/signup')}>
                    <IoSparkles size={14} /> Create Free Account
                  </button>
                </div>
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8 }}>
                  {TRUST_PILLS.map(({ Icon, label }, i) => (
                    <span key={i} className="pill-badge"><Icon size={11} color="#00e5b0" /> {label}</span>
                  ))}
                </div>
              </div>

              {/* Right — chat UI */}
              <div style={{ animation: 'fadeUp 0.8s ease 0.15s both' }}>
                <div style={{ background: 'rgba(8,18,32,0.97)', border: '1px solid rgba(0,180,130,0.18)', borderRadius: 22, overflow: 'hidden', boxShadow: '0 48px 96px rgba(0,0,0,0.6)', animation: 'floatY 7s ease-in-out infinite' }}>
                  {/* Chat topbar */}
                  <div style={{ background: 'rgba(0,128,128,0.12)', borderBottom: '1px solid rgba(0,180,130,0.12)', padding: '12px 16px', display: 'flex', alignItems: 'center', gap: 10 }}>
                    <div style={{ display: 'flex', gap: 5 }}>
                      {['#ff5f57', '#ffbd2e', '#28c940'].map((c, i) => <div key={i} style={{ width: 10, height: 10, borderRadius: '50%', background: c }} />)}
                    </div>
                    <div style={{ width: 34, height: 34, borderRadius: '50%', background: 'linear-gradient(135deg,#008080,#00b899)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                      <PiFilmSlateDuotone size={18} color="#fff" />
                    </div>
                    <div>
                      <div style={{ fontSize: 13, fontWeight: 700, color: '#f9fafb' }}>Kissa Ek Raat Ka · Crew</div>
                      <div style={{ fontSize: 11, color: '#00e5b0', display: 'flex', alignItems: 'center', gap: 4 }}>
                        <span style={{ width: 6, height: 6, borderRadius: '50%', background: '#00e5b0', display: 'inline-block', animation: 'pulse 2s ease infinite' }} />
                        5 members online
                      </div>
                    </div>
                    <div style={{ marginLeft: 'auto' }}>
                      <div style={{ background: 'rgba(0,180,130,0.12)', border: '1px solid rgba(0,180,130,0.25)', borderRadius: 50, padding: '4px 10px', fontSize: 10, fontWeight: 700, color: '#00e5b0', display: 'flex', alignItems: 'center', gap: 4 }}>
                        <FaLock size={8} /> Encrypted
                      </div>
                    </div>
                  </div>
                  {/* Messages */}
                  <div style={{ padding: '16px 14px 8px' }}>
                    {CHAT_MESSAGES.map((m, i) => (
                      <div key={i} style={{ display: 'flex', flexDirection: m.right ? 'row-reverse' : 'row', alignItems: 'flex-end', gap: 8, marginBottom: 12, animation: 'fadeUp 0.5s cubic-bezier(0.34,1.56,0.64,1) both', animationDelay: m.delay }}>
                        <div style={{ width: 30, height: 30, borderRadius: '50%', background: m.right ? 'linear-gradient(135deg,#008080,#00b899)' : 'linear-gradient(135deg,#1a2a3a,#2d3f52)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 11, fontWeight: 700, color: '#fff', flexShrink: 0, border: '1.5px solid rgba(255,255,255,0.08)' }}>
                          {m.initials}
                        </div>
                        <div style={{ maxWidth: '72%' }}>
                          {!m.right && <div style={{ fontSize: 10, color: 'rgba(255,255,255,0.35)', marginBottom: 3, marginLeft: 2 }}>{m.from} · {m.role}</div>}
                          <div style={{ background: m.right ? 'linear-gradient(135deg,#008080,#006868)' : 'rgba(22,36,54,0.95)', borderRadius: m.right ? '18px 18px 4px 18px' : '18px 18px 18px 4px', padding: '10px 13px', border: '1px solid rgba(255,255,255,0.06)' }}>
                            <p style={{ margin: 0, fontSize: 12.5, color: '#f3f4f6', lineHeight: 1.55 }}>{m.msg}</p>
                            <div style={{ display: 'flex', alignItems: 'center', gap: 4, marginTop: 4, justifyContent: m.right ? 'flex-end' : 'flex-start' }}>
                              <span style={{ fontSize: 10, color: 'rgba(255,255,255,0.35)' }}>{m.time}</span>
                              {m.right && <FaCheckDouble size={9} color="#00e5b0" />}
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                    {/* Typing */}
                    <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 10 }}>
                      <div style={{ width: 30, height: 30, borderRadius: '50%', background: 'linear-gradient(135deg,#1a2a3a,#2d3f52)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 11, fontWeight: 700, color: '#fff' }}>K</div>
                      <div style={{ background: 'rgba(22,36,54,0.95)', borderRadius: '18px 18px 18px 4px', padding: '10px 14px', display: 'flex', gap: 5, alignItems: 'center', border: '1px solid rgba(255,255,255,0.06)' }}>
                        {[0, 0.2, 0.4].map((d, i) => <div key={i} className="typing-dot" style={{ animationDelay: `${d}s` }} />)}
                      </div>
                      <span style={{ fontSize: 11, color: 'rgba(255,255,255,0.3)' }}>Kavya is typing...</span>
                    </div>
                  </div>
                  {/* Input */}
                  <div style={{ padding: '10px 14px 14px', borderTop: '1px solid rgba(255,255,255,0.05)', display: 'flex', gap: 10, alignItems: 'center' }}>
                    <div style={{ flex: 1, background: 'rgba(255,255,255,0.04)', border: '1px solid rgba(255,255,255,0.08)', borderRadius: 50, padding: '9px 16px', fontSize: 13, color: 'rgba(255,255,255,0.25)' }}>Message your crew...</div>
                    <div style={{ width: 36, height: 36, borderRadius: '50%', background: 'linear-gradient(135deg,#008080,#00b899)', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer' }}>
                      <FiSend size={14} color="#fff" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>

          {/* ════════════ ITALIC QUOTE ════════════ */}
          <section style={{ textAlign: 'center', padding: '10px 24px 70px', maxWidth: 800, margin: '0 auto' }}>
            <p style={{ fontFamily: "'Playfair Display',serif", fontSize: 'clamp(18px,3vw,28px)', fontStyle: 'italic', color: 'rgba(255,255,255,0.32)', lineHeight: 1.75 }}>
              "Whether you are a student shooting your first short film, a freelance filmmaker building your network, or a production house managing your next feature — this is your space."
            </p>
          </section>

          {/* ════════════ STATS ════════════ */}
          <section style={{ borderTop: '1px solid rgba(0,180,130,0.08)', borderBottom: '1px solid rgba(0,180,130,0.08)', background: 'rgba(0,128,128,0.03)', padding: '48px clamp(16px,4vw,48px)' }}>
            <div className="stats-grid" style={{ maxWidth: 960, margin: '0 auto', display: 'grid', gridTemplateColumns: 'repeat(5,1fr)', gap: 32, textAlign: 'center' }}>
              {[
                { val: '100%', label: 'End-to-End Encrypted' },
                { val: '0', label: 'Ads or Spam. Ever.' },
                { val: 'Free', label: 'For Every User' },
                { val: '∞', label: 'Message History' },
                { val: 'Real', label: 'Time Delivery' },
              ].map((s, i) => (
                <div key={i}>
                  <div className="stat-num" style={{ animationDelay: `${i * 0.12}s` }}>{s.val}</div>
                  <div style={{ fontSize: 12, color: 'rgba(255,255,255,0.36)', marginTop: 6, letterSpacing: '0.04em' }}>{s.label}</div>
                </div>
              ))}
            </div>
          </section>

          {/* ════════════ THE REAL PROBLEM ════════════ */}
          <section style={{ maxWidth: 1000, margin: '0 auto', padding: '80px clamp(16px,4vw,48px)' }}>
            <div className="problem-grid" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 56, alignItems: 'start' }}>
              <div>
                <h2 style={{ fontFamily: "'Playfair Display',serif", fontSize: 'clamp(26px,4vw,42px)', fontWeight: 900, lineHeight: 1.15, marginBottom: 24, letterSpacing: '-0.02em' }}>
                  Indian Films Are Made on Scattered Chats.<br />
                  <span className="msg-gradient-text">They Deserve Better.</span>
                </h2>
                <p style={{ fontSize: 16, color: 'rgba(255,255,255,0.5)', lineHeight: 1.85, marginBottom: 20 }}>
                  Right now, somewhere in India, a director is sending a script update in a group of 47 people. A cinematographer is scrolling through 300 messages looking for the location address. An aspiring actor is wondering which number to call about an audition they saw on social media.
                </p>
                <p style={{ fontSize: 16, color: 'rgba(255,255,255,0.5)', lineHeight: 1.85, marginBottom: 20 }}>It does not have to be this way.</p>
                <p style={{ fontSize: 16, color: 'rgba(255,255,255,0.5)', lineHeight: 1.85 }}>
                  ProducerBuddy Messaging was built for the full spectrum of Indian cinema — from the film student making their debut short to the production house managing multiple features simultaneously. Everyone deserves a professional, secure space to communicate.
                </p>
              </div>
              <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
                {PROBLEMS.map(({ Icon, problem, who }, i) => (
                  <div key={i} className="problem-card" style={{ animationDelay: `${i * 0.08}s` }}>
                    <div style={{ width: 36, height: 36, borderRadius: 10, background: 'rgba(239,68,68,0.08)', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, border: '1px solid rgba(239,68,68,0.2)' }}>
                      <Icon size={16} color="#ef4444" />
                    </div>
                    <div>
                      <p style={{ margin: 0, fontSize: 14, fontWeight: 700, color: '#1a1a1a', marginBottom: 3 }}>{problem}</p>
                      <p style={{ margin: 0, fontSize: 12, color: '#c04040' }}>{who}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </section>

          {/* ════════════ COMPARISON ════════════ */}
          <section style={{ background: 'rgba(0,128,128,0.03)', borderTop: '1px solid rgba(0,180,130,0.08)', padding: '80px clamp(16px,4vw,48px)' }}>
            <div style={{ maxWidth: 1000, margin: '0 auto' }}>
              <div style={{ textAlign: 'center', marginBottom: 52 }}>
                <h2 style={{ fontFamily: "'Playfair Display',serif", fontSize: 'clamp(26px,4vw,42px)', fontWeight: 900, letterSpacing: '-0.02em', marginBottom: 14 }}>The Difference Is Clear</h2>
                <p style={{ fontSize: 16, color: 'rgba(255,255,255,0.45)', maxWidth: 500, margin: '0 auto', lineHeight: 1.7 }}>Generic messaging apps were built for everyone. ProducerBuddy Messaging was built for you.</p>
              </div>

              <div className="comparison-box comparison-grid" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr' }}>
                {/* Generic column — white bg, dark text */}
                <div style={{ padding: '32px 28px', background: '#ffffff' }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 28 }}>
                    <TbMessageOff size={14} color="#888" />
                    <span style={{ fontSize: 12, fontWeight: 700, letterSpacing: '0.1em', textTransform: 'uppercase', color: '#888' }}>Generic Messaging Apps</span>
                  </div>
                  {COMPARISON.map(([bad], i) => (
                    <div key={i} style={{ display: 'flex', alignItems: 'flex-start', gap: 10, marginBottom: 18 }}>
                      <FaBan size={12} color="#ef4444" style={{ marginTop: 3, flexShrink: 0 }} />
                      <span style={{ fontSize: 14, color: '#555', lineHeight: 1.6 }}>{bad}</span>
                    </div>
                  ))}
                </div>

                {/* PB column — white bg, teal text */}
                <div style={{ padding: '32px 28px', background: '#f0fffe', borderLeft: '2px solid rgba(0,180,130,0.3)' }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 28 }}>
                    <BsChatDotsFill size={13} color="#008080" />
                    <span style={{ fontSize: 12, fontWeight: 700, letterSpacing: '0.1em', textTransform: 'uppercase', color: '#008080' }}>ProducerBuddy Messaging</span>
                  </div>
                  {COMPARISON.map(([, good], i) => (
                    <div key={i} style={{ display: 'flex', alignItems: 'flex-start', gap: 10, marginBottom: 18 }}>
                      <FaCheckDouble size={12} color="#008080" style={{ marginTop: 3, flexShrink: 0 }} />
                      <span style={{ fontSize: 14, color: '#0a4040', fontWeight: 600, lineHeight: 1.6 }}>{good}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </section>

          {/* ════════════ FEATURES GRID ════════════ */}
          <section style={{ maxWidth: 1100, margin: '0 auto', padding: '80px clamp(16px,4vw,48px)' }}>
            <div style={{ textAlign: 'center', marginBottom: 56 }}>
              <h2 style={{ fontFamily: "'Playfair Display',serif", fontSize: 'clamp(26px,4vw,42px)', fontWeight: 900, letterSpacing: '-0.02em', marginBottom: 14 }}>Everything in One Place</h2>
              <p style={{ fontSize: 16, color: 'rgba(255,255,255,0.45)', maxWidth: 500, margin: '0 auto', lineHeight: 1.7 }}>Designed specifically for how Indian film productions actually communicate — on set, off set, and everywhere in between.</p>
            </div>
            <div className="features-grid" style={{ display: 'grid', gridTemplateColumns: 'repeat(3,1fr)', gap: 20 }}>
              {FEATURES.map(({ Icon, title, desc }, i) => (
                <div key={i} className="msg-card" style={{ padding: '28px 24px', animation: 'fadeUp 0.5s ease both', animationDelay: `${i * 0.06}s` }}>
                  <div style={{ width: 52, height: 52, borderRadius: 14, background: 'linear-gradient(135deg,rgba(0,180,130,0.15),rgba(0,128,128,0.08))', border: '1px solid rgba(0,180,130,0.3)', display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: 18 }}>
                    <Icon size={22} color="#008080" />
                  </div>
                  <h3 style={{ fontFamily: "'Playfair Display',serif", fontSize: 17, fontWeight: 700, marginBottom: 10 }}>{title}</h3>
                  <p style={{ fontSize: 14, lineHeight: 1.7, margin: 0 }}>{desc}</p>
                </div>
              ))}
            </div>
          </section>

          {/* ════════════ PRIVACY ════════════ */}
          <section style={{ padding: '80px clamp(16px,4vw,48px)', background: 'rgba(0,128,128,0.03)', borderTop: '1px solid rgba(0,180,130,0.08)' }}>
            <div style={{ maxWidth: 820, margin: '0 auto', textAlign: 'center' }}>
              <div style={{ width: 72, height: 72, borderRadius: 20, background: '#ffffff', border: '2px solid rgba(0,180,130,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 24px', animation: 'glowFlow 4s ease-in-out infinite' }}>
                <FaUserSecret size={32} color="#008080" />
              </div>
              <h2 style={{ fontFamily: "'Playfair Display',serif", fontSize: 'clamp(24px,4vw,40px)', fontWeight: 900, letterSpacing: '-0.02em', marginBottom: 20 }}>
                Your Conversations Are Sacred.<br />
                <span className="msg-gradient-text">We Take That Seriously.</span>
              </h2>
              <p style={{ fontSize: 17, color: 'rgba(255,255,255,0.5)', lineHeight: 1.85, maxWidth: 620, margin: '0 auto 16px' }}>
                A film script is your intellectual property. A casting decision is confidential. A budget discussion is private. A director's creative vision is sacred.
              </p>
              <p style={{ fontSize: 17, color: 'rgba(255,255,255,0.5)', lineHeight: 1.85, maxWidth: 620, margin: '0 auto 40px' }}>
                Every message on ProducerBuddy is end-to-end encrypted. We cannot read it. We do not store it in a readable form. We will never sell it, scan it or use it for advertising. Your conversations exist for one purpose — to help you make great films.
              </p>
              <div style={{ display: 'flex', flexWrap: 'wrap', gap: 10, justifyContent: 'center' }}>
                {SECURITY_ITEMS.map(({ Icon, label }, i) => (
                  <div key={i} className="security-pill">
                    <Icon size={11} color="#008080" /> {label}
                  </div>
                ))}
              </div>
            </div>
          </section>

          {/* ════════════ FINAL CTA ════════════ */}
          <section style={{ textAlign: 'center', padding: 'clamp(64px,10vw,100px) clamp(16px,4vw,48px)' }}>
            <div style={{ maxWidth: 680, margin: '0 auto' }}>
              <div style={{ width: 72, height: 72, borderRadius: 20, background: 'linear-gradient(135deg,#008080,#00b899)', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 24px', boxShadow: '0 16px 48px rgba(0,128,128,0.35)' }}>
                <PiFilmSlateDuotone size={34} color="#fff" />
              </div>
              <h2 style={{ fontFamily: "'Playfair Display',serif", fontSize: 'clamp(28px,5vw,52px)', fontWeight: 900, letterSpacing: '-0.02em', marginBottom: 20, lineHeight: 1.15 }}>
                Your Story Starts With<br />
                <span className="msg-gradient-text">a Single Message.</span>
              </h2>
              <p style={{ fontSize: 17, color: 'rgba(255,255,255,0.48)', lineHeight: 1.85, maxWidth: 520, margin: '0 auto 44px' }}>
                Join filmmakers, producers, crew members and film enthusiasts already connecting on ProducerBuddy. Free to join. Free to message. Always.
              </p>
              <div style={{ display: 'flex', gap: 14, justifyContent: 'center', flexWrap: 'wrap', marginBottom: 24 }}>
                <button className="msg-cta-primary" style={{ fontSize: 16, padding: '17px 38px' }} onClick={goToMessenger}>
                  <BsChatDotsFill size={16} />
                  {loggedIn ? 'Open Messenger' : 'Join Free — Start Messaging'}
                </button>
                <button className="msg-cta-ghost" style={{ fontSize: 16, padding: '17px 38px' }} onClick={() => navigate('/')}>
                  <FiArrowLeft size={15} /> Back to Home
                </button>
              </div>
              <p style={{ fontSize: 13, color: 'rgba(255,255,255,0.2)', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 16, flexWrap: 'wrap' }}>
                <span style={{ display: 'flex', alignItems: 'center', gap: 5 }}><FaLock size={10} /> No credit card required</span>
                <span style={{ display: 'flex', alignItems: 'center', gap: 5 }}><FaMobileAlt size={10} /> No phone number required</span>
                <span style={{ display: 'flex', alignItems: 'center', gap: 5 }}><FaCheckDouble size={10} /> Free forever</span>
                <span style={{ display: 'flex', alignItems: 'center', gap: 5 }}><FaShieldAlt size={10} /> All messages encrypted</span>
              </p>
            </div>
          </section>

        </div>
      </div>
    </>
  );
};

export default MessagingFeaturePage;